import { Component, Input } from '@angular/core';
import { TableSection } from 'src/app/model/shared/table-section';

import { documentToHtmlString } from '.';

@Component({
  selector: 'app-common-types-datalists-table-section',
  templateUrl: './common-types-datalists-table-section.component.html',
  styleUrls: ['./common-types-datalists-table-section.component.scss']
})
export class CommonTypesDatalistsTableSectionComponent {
  @Input() tableSections: TableSection[] = [];
  constructor() {}

  returnHtmlFromRichText(richText: any): string {
    if (richText === undefined || richText === null || richText.nodeType !== 'document') {
      return '<p>Error</p>';
    }

    return documentToHtmlString(richText);
  }
}
